<div *ngIf="repeatCardsCount != null && totalCardsCount != null" class="open-widget">
  <div class="header">
    <tabler-icon name="repeat"></tabler-icon>
    <span>Bereit zur Wiederholung</span>
  </div>
  <div class="content">
    <!--<svg width="30" height="30" viewBox="0 0 30 30" class="circular-progress" [style.--progress.%]="75">
      <circle class="bg"></circle>
      <circle class="fg"></circle>
    </svg>-->
    <span class="open-cards-count">{{repeatCardsCount}}</span>
    <span class="total-cards-count">von {{totalCardsCount}}</span>
  </div>
  <app-progress-bar *ngIf="!showButtonToSmartRepetition" [progress]="(repeatCardsCount == 0 && totalCardsCount == 0) ? 0 : (repeatCardsCount! / totalCardsCount!) * 100" [color]="'primary'"></app-progress-bar>

  <button *ngIf="showButtonToSmartRepetition" [routerLink]="'/smart-repetition'">
    <span>Smartes Wiederholen</span>
    <tabler-icon name="arrow-right"></tabler-icon>
  </button>
</div>

